import RestClient from './RestClient';
import { Stat } from '../../models';
import { getApiErrorMessage } from './getApiErrorMessage';
import { sanitizeStatsParams } from './statsParams';

class Stats extends RestClient {
    constructor() {
        super({
            "model"      : Stat,
            "entryPoint" : "stats",
            "resource"   : "stat",
            "resources"  : "stats",
            "id_field"   : "_id",
            "sortBy"     : "films"
        });
    }

    get(type, params) {
        // remove empty filter values
        params = sanitizeStatsParams(params);

        return this.GET(`/stats/${type}`, params)
            .then(response => response.json())
            .then(json => {
                if (json.stats) {
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    /**
     * Render the distributor report as an engine-generated PDF.
     * Uses the same filters as get('movie', …) plus an optional preview language.
     *
     * @param {Object} params movie stats filters (currency, edition, start/end dates,
     *                         movie, version, place(s), hall(s), section_id, …) + optional lang
     * @return {Promise<Blob>}
     */
    reportPdf(params) {
        // remove empty filter values
        params = sanitizeStatsParams(params);

        return this.POST('/stats/movie_preview_report_pdf', params, null, {
            Accept: 'application/pdf',
        }).then(async (response) => {
            if (response.ok)
                return response.blob();

            let message = 'Unable to generate report PDF';
            try {
                const json = await response.json();
                message = json?.flash?.error || message;
            } catch (e) {
                // ignore parse errors on non-json bodies
            }
            throw new Error(message);
        });
    }

    /**
     * Send the distributor report by email.
     * Body = the same movie stats filters plus optional lang, optional `to`
     * { name, address }, the live `distributor` object, and optional
     * `subject` / `body_html` overrides from the send modal preview.
     *
     * @param {Object} params filters + { lang, to, distributor }
     * @return {Promise<Object>} { success, to, lang, response }
     */
    sendReport(params) {
        // remove empty filter values (keep nested objects like `distributor`/`to`)
        params = sanitizeStatsParams(params);

        return this.POST('/stats/movie_send_report', params)
            .then(response => response.json())
            .then(json => {
                if (json.success)
                    return json;
                throw new Error(getApiErrorMessage(json));
            });
    }
}

const StatsApi = new Stats();

export default StatsApi;
